import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "最少保留1个", -1);

const _hoisted_2 = {
  class: "base_main_margin_top"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "base_details_content_second"
};
import { ref } from "vue";
import DynamicParams from "@com/DynamicParams.vue";
import ChooseProduct2 from "@com/marketing/ChooseProduct2.vue";
import $ from "@util/base";
import { $msg, $box } from "@ui/msg";
import api from "@api/homepage";
const typeName = "banner";
export default {
  __name: 'BannerConfigure',

  setup(__props) {
    const data = ref([]);
    const bannerParams = ref(null);
    const modifyIndex = ref(null);
    let type = "add";

    function showAddBanner(index) {
      openDrawer();

      if (index != undefined) {
        modifyIndex.value = index;
        type = "modify";
        title.value = "修改Banner";
      } else {
        modifyIndex.value = null;
        type = "add";
        title.value = "";
        basicForm.value = {
          id: null,
          bannerPic: [],
          linkToType: null,
          linkToItem: null,
          product: {
            code: null,
            name: null
          },
          link: null
        };
      }
    }

    function addBanner() {
      // if (bannerParams.value.getValue().length < 5) {
      //   showAddBanner();
      // } else {
      //   $msg.error("最多添加5个");
      // }
      showAddBanner();
    }

    function delBanner(index) {
      if (bannerParams.value.getValue().length == 1) {
        $msg.error("最少保留1个");
        return false;
      } else {
        let data = bannerParams.value.getValue()[index];
        $box.open("删除确认", "是否删除", () => {
          api.del(typeName, data.id, () => {
            $msg.succ("删除成功");
            getData();
          });
        });
      }
    }

    function modifyBanner(index) {
      showAddBanner(index);
      setDetailsData(index);
    }

    function sortBanner(data) {
      let idList = data.map(e => {
        return e.id;
      });
      api.sort(typeName, idList.reverse(), () => {
        $msg.succ("排序修改成功");
        getData();
      });
    }

    function setDetailsData(index) {
      let data = bannerParams.value.getValue()[index];
      basicForm.value.id = data.id;
      basicForm.value.bannerPic = [data.bannerPic];
      basicForm.value.linkToType = data.linkToType;
      basicForm.value.linkToItem = data.linkToItem;
      linkToTypeChange(data.linkToType);

      if (linkToType.value == "link") {
        basicForm.value.link = data.linkToItem;
      }

      if (linkToType.value == "goods" || linkToType.value == "travel" || linkToType.value == "travel3" || linkToType.value == "hotel" || linkToType.value == "gift" || linkToType.value == "classify") {
        basicForm.value.product.code = data.linkToItem;
        basicForm.value.product.name = data.linkToItemName;
      }
    }

    const title = ref("新增Banner");
    const drawer = ref(false);

    function openDrawer() {
      drawer.value = true;
    }

    function closeDrawer() {
      drawer.value = false;
    }

    const typeOptions = [{
      id: "1024001",
      name: "无"
    }, {
      id: "1024002",
      name: "商品"
    }, {
      id: "1024003",
      name: "旅行"
    }, {
      id: "1024004",
      name: "酒店"
    }, {
      id: "1024006",
      name: "综合活动"
    }, {
      id: "1024007",
      name: "分类"
    }, {
      id: "1024005",
      name: "链接"
    }, {
      id: "1024008",
      name: "旅商活动"
    }];
    const basicFormRef = ref(null);
    const basicForm = ref({
      id: null,
      bannerPic: [],
      linkToType: null,
      linkToItem: null,
      product: {
        code: null,
        name: null
      },
      link: null
    });
    const basicRules = {
      bannerPic: [{
        required: true,
        message: "请上传Banner图片",
        trigger: "blur"
      }],
      linkToType: [{
        required: true,
        message: "请选择跳转类型",
        trigger: "blur"
      }]
    };
    const linkToType = ref(null);
    const linkToTypeText = ref('');

    function linkToTypeChange(val) {
      basicForm.value.product = {
        code: null,
        name: null
      };
      basicForm.value.link = null;

      switch (val) {
        case "1024001":
          linkToType.value = null;
          break;

        case "1024002":
          linkToType.value = "goods";
          linkToTypeText.value = "商品";
          break;

        case "1024003":
          linkToType.value = "travel";
          linkToTypeText.value = "旅行";
          break;

        case "1024004":
          linkToType.value = "hotel";
          linkToTypeText.value = "酒店";
          break;

        case "1024005":
          linkToType.value = "link";
          break;

        case "1024006":
          linkToType.value = "gift";
          linkToTypeText.value = "综合活动";
          break;

        case "1024007":
          linkToType.value = "classify";
          linkToTypeText.value = "分类";
          break;

        case "1024008":
          linkToType.value = "travel3";
          linkToTypeText.value = "旅商活动";
          break;
      }
    }

    const chooseProductRef = ref(null);

    function openChooseProduct() {
      chooseProductRef.value.show(linkToType.value);
    }

    function chooseProduct2(data) {
      basicForm.value.product.code = data.code;
      basicForm.value.product.name = data.name;
    }

    function checkLinkToItem() {
      if (linkToType.value == "link" && $.isNull(basicForm.value.link)) {
        $msg.error("请输入链接地址");
        return false;
      } // if (
      //   (linkToType.value == "goods" ||
      //     linkToType.value == "travel" ||
      //     linkToType.value == "hotel" ||
      //     linkToType.value == "gift") &&
      //   $.isNull(basicForm.value.product.code)
      // ) {
      //   $msg.error("请选择商品");
      //   return false;
      // }


      return true;
    }

    function saveBanner() {
      basicFormRef.value.validate(valid => {
        if (valid && checkLinkToItem()) {
          let form = $.deepCopy(basicForm.value);
          form.bannerPic = form.bannerPic[0];

          if (linkToType.value == "link") {
            form.linkToItem = form.link;
          }

          if (linkToType.value == "goods" || linkToType.value == "travel" || linkToType.value == "travel3" || linkToType.value == "hotel" || linkToType.value == "gift" || linkToType.value == "classify") {
            form.linkToItem = form.product.code;
          }

          delete form.link;
          delete form.product;
          $.handleCRU(type, {
            add: () => {
              delete form.id;
              addData(form);
            },
            modify: () => {
              modifyData(form);
            }
          });
        }
      });
    }

    function addData(form) {
      api.add(typeName, form, () => {
        $msg.succ("新增成功");
        closeDrawer();
        getData();
      });
    }

    function modifyData(form) {
      api.update(typeName, form, () => {
        $msg.succ("修改成功");
        closeDrawer();
        getData();
      });
    }

    getData();

    function getData() {
      api.list(typeName, val => {
        // data.value = [
        //   {
        //     id: 2,
        //     bannerPic:
        //       "https://cwimgtest.oss-cn-beijing.aliyuncs.com/img/20221001/9db7dc8d9b8948fb80543beca53ee4bb.jpeg",
        //     sortNum: 200,
        //     linkToType: "1024001",
        //     linkToItem: null,
        //     linkToItemName: null,
        //   },
        //   {
        //     id: 1,
        //     bannerPic:
        //       "https://cwimgtest.oss-cn-beijing.aliyuncs.com/img/20221001/80bd4c9f3fe343cd909bbdf91172aa09.jpg",
        //     sortNum: 100,
        //     linkToType: "1024003",
        //     linkToItem: "8111050",
        //     linkToItemName: "暗示法",
        //   },
        // ];
        data.value = val.list.map(e => {
          // 1024001 无、1024002 商品、1024003 旅行、1024004 酒店、1024005 链接
          switch (e.linkToType) {
            case "1024001":
              e.typeValue = "无";
              break;

            case "1024002":
              e.typeValue = "商品";
              break;

            case "1024003":
              e.typeValue = "旅行";
              break;

            case "1024004":
              e.typeValue = "酒店";
              break;

            case "1024005":
              e.typeValue = "链接";
              break;

            case "1024006":
              e.typeValue = "综合活动";
              break;

            case "1024008":
              e.typeValue = "旅商活动";
              break;
          }

          return e;
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_DynamicParams2 = _resolveComponent("DynamicParams2");

      const _component_UploadPicture = _resolveComponent("UploadPicture");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_drawer = _resolveComponent("el-drawer");

      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createBlock(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_DynamicParams2, {
          ref_key: "bannerParams",
          ref: bannerParams,
          showDefault: false,
          customAdd: true,
          customDel: true,
          customMove: true,
          operation: {
            add: true,
            modify: true,
            move: true,
            del: true
          },
          data: data.value,
          onAdd: addBanner,
          onDelete: delBanner,
          onModify: modifyBanner,
          onMove: sortBanner,
          addText: "添加Banner"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "Banner图片",
            align: "center"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_image, {
              fit: "contain",
              src: scope.row.bannerPic,
              style: {
                // width: '250px',
                height: '200px'
              }
            }, null, 8, ["src"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "跳转类型",
            align: "center",
            width: "150px"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.typeValue), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]), _createVNode(_component_el_drawer, {
          "custom-class": "base_drawer",
          modelValue: drawer.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => drawer.value = $event),
          "close-on-click-modal": false,
          title: title.value,
          "with-header": true,
          size: 850
        }, {
          footer: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            onClick: closeDrawer
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: saveBanner
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
            ref_key: "basicFormRef",
            ref: basicFormRef,
            model: basicForm.value,
            rules: basicRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "Banner图片",
              prop: "bannerPic"
            }, {
              default: _withCtx(() => [_createVNode(_component_UploadPicture, {
                modelValue: basicForm.value.bannerPic,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => basicForm.value.bannerPic = $event),
                limit: 1,
                imgSize: "375*375",
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "fileSize"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "跳转类型",
              prop: "linkToType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: basicForm.value.linkToType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => basicForm.value.linkToType = $event),
                onChange: linkToTypeChange
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(typeOptions, (item, index) => {
                  return _createVNode(_component_el_radio, {
                    key: index,
                    label: item.id
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [linkToType.value != 'link' && linkToType.value ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: basicForm.value.product.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => basicForm.value.product.name = $event),
                placeholder: '添加' + linkToTypeText.value + '，为空时将跳转' + linkToTypeText.value + '列表'
              }, {
                append: _withCtx(() => [_createVNode(_component_el_button, {
                  onClick: openChooseProduct,
                  type: "primary"
                }, {
                  default: _withCtx(() => [_createTextVNode("添加" + _toDisplayString(linkToTypeText.value), 1)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue", "placeholder"])) : _createCommentVNode("", true), linkToType.value == 'link' ? (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: basicForm.value.link,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => basicForm.value.link = $event),
                placeholder: "链接地址"
              }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])])])]),
          _: 1
        }, 8, ["modelValue", "title"]), _createVNode(ChooseProduct2, {
          ref_key: "chooseProductRef",
          ref: chooseProductRef,
          onChooseProduct2: chooseProduct2
        }, null, 512)]),
        _: 1
      });
    };
  }

};